import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-987b8e32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "information-template-wrapper" }
const _hoisted_2 = { class: "info-table-wrapper" }
const _hoisted_3 = { class: "table-toolbar" }
const _hoisted_4 = { class: "table-wrapper" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filter_search = _resolveComponent("filter-search")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_InfoWrapper = _resolveComponent("InfoWrapper")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_edit_or_add_modal = _resolveComponent("edit-or-add-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_InfoWrapper, { title: "消息模板配置" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.tableInfo.isHas)
              ? (_openBlock(), _createBlock(_component_filter_search, {
                  key: 0,
                  rows: _ctx.tableInfo.rows,
                  rules: _ctx.tableInfo.rules,
                  onUpdateReqParams: _ctx.tableInfo.updateReqParams,
                  onSearch: _ctx.tableInfo.search,
                  onResearch: _ctx.tableInfo.research
                }, null, 8, ["rows", "rules", "onUpdateReqParams", "onSearch", "onResearch"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_button, {
              type: "primary",
              style: {"margin-left":"15px"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addInfo.showCreateModal()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_table, {
              bordered: "",
              "row-key": "id",
              scroll: { x: '2000px' },
              columns: _ctx.tableInfo.cols,
              "data-source": _ctx.tableInfo.data,
              pagination: _ctx.tableInfo.paginationConfig,
              "row-selection": { selectedRowKeys: _ctx.tableInfo.state.selectedRowKeys, onChange: _ctx.tableInfo.onSelectChange },
              onChange: _ctx.tableInfo.onTableChange,
              rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
            }, {
              isSms: _withCtx(({ record }) => [
                (record.isSendSms != null)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(record.isSendSms === 0 ? '否' : '是'), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              ope: _withCtx(({ record }) => [
                _createElementVNode("span", {
                  class: "cursor",
                  onClick: ($event: any) => (_ctx.tableInfo.seeDetail(record))
                }, "详情", 8, _hoisted_5),
                _createElementVNode("span", {
                  class: "cursor",
                  onClick: ($event: any) => (_ctx.addModalInfo.edit(record))
                }, "编辑", 8, _hoisted_6),
                _createElementVNode("span", {
                  class: "cursor delete-cursor",
                  onClick: ($event: any) => (_ctx.delModalInfo.doDel(record))
                }, _toDisplayString(!record.toDoTemplateConfig ? '删除':'重置'), 9, _hoisted_7)
              ]),
              _: 1
            }, 8, ["columns", "data-source", "pagination", "row-selection", "onChange", "rowClassName"])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.addModalInfo.visible,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.addModalInfo.visible) = $event)),
      width: "600px",
      onOk: _ctx.addModalInfo.ok,
      "ok-text": "确定",
      title: _ctx.addModalInfo.title
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: _ctx.addModalInfo.setValidateForm,
          model: _ctx.addModalInfo.form,
          rules: _ctx.addModalInfo.rules,
          "label-col": {span:6},
          "wrapper-col": {span:18}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "责任对象类型",
              name: "dutyObjectType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  style: {"width":"400px"},
                  ref: "select",
                  value: _ctx.addModalInfo.form.dutyObjectType,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addModalInfo.form.dutyObjectType) = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tableInfo.dutyObjectTypeChange()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableInfo.objectTypeList.arr, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            (_ctx.addModalInfo.form.dutyObjectType == 0)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "责任对象",
                  name: "dutyUserList"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      style: {"width":"400px"},
                      mode: "tags",
                      value: _ctx.addModalInfo.form.dutyUserList,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addModalInfo.form.dutyUserList) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableInfo.userList.arr, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.realName + ' ( ' + item.username + ' ) '), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.addModalInfo.form.dutyObjectType != 3 && _ctx.addModalInfo.form.dutyObjectType != 4)
                    ? (_openBlock(), _createBlock(_component_a_form_item, {
                        key: 0,
                        label: "责任对象",
                        name: "dutyObjectId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            style: {"width":"400px"},
                            ref: "select",
                            value: _ctx.addModalInfo.form.dutyObjectId,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addModalInfo.form.dutyObjectId) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableInfo.dutyObjectList.arr, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: item.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64)),
            _createVNode(_component_a_form_item, {
              label: "待办内容模板",
              name: "contentTemplate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  style: {"width":"400px","vertical-align":"top"},
                  value: _ctx.addModalInfo.form.contentTemplate,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addModalInfo.form.contentTemplate) = $event)),
                  rows: 2,
                  placeholder: "在此输入待办内容模板"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "备注",
              name: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  style: {"width":"400px","vertical-align":"top"},
                  value: _ctx.addModalInfo.form.remark,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addModalInfo.form.remark) = $event)),
                  rows: 2,
                  placeholder: "在此输入备注"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "是否发送短信",
              name: "isSendSms"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  options: _ctx.addModalInfo.options,
                  value: _ctx.addModalInfo.form.isSendSms,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addModalInfo.form.isSendSms) = $event))
                }, null, 8, ["options", "value"])
              ]),
              _: 1
            }),
            (_ctx.addModalInfo.form.isSendSms)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 2,
                  label: "短信模板",
                  name: "smsTemplateCode"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.addModalInfo.form.smsTemplateCode,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.addModalInfo.form.smsTemplateCode) = $event)),
                      placeholder: "下拉选取短信模板",
                      onChange: _ctx.addModalInfo.changeSmsCode,
                      style: {"width":"400px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addModalInfo.smsMessageTypeList, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            label: item.name,
                            key: item.code
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "onChange"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.addModalInfo.form.isSendSms)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 3,
                  label: "短信模板内容配置",
                  name: "smsTemplateConfig"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      style: {"width":"400px","vertical-align":"top"},
                      value: _ctx.addModalInfo.form.smsTemplateConfig,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.addModalInfo.form.smsTemplateConfig) = $event)),
                      rows: 2,
                      placeholder: "在此输入短信模板内容配置"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["visible", "onOk", "title"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.tableInfo.visible,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tableInfo.visible) = $event)),
      title: "配置详情",
      footer: null,
      width: "1200px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_descriptions, {
            title: "基础配置",
            bordered: "",
            layout: "vertical",
            column: 4
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_descriptions_item, {
                label: "类型名称",
                span: 1
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tableInfo.detailData.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, {
                label: "类型编码",
                span: 1
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tableInfo.detailData.code), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, {
                label: "类型备注",
                span: 2
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tableInfo.detailData.remark), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, {
                label: "责任对象",
                span: 2
              }, {
                default: _withCtx(() => [
                  (_ctx.tableInfo.detailData.toDoTemplateConfig?.dutyObjectType === 3 || _ctx.tableInfo.detailData.toDoTemplateConfig?.dutyObjectType === 4)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.tableInfo.getObjectTypeName(_ctx.tableInfo.detailData.toDoTemplateConfig?.dutyObjectType)), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.tableInfo.detailData.dutyObjectStr), 1)
                      ], 64))
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, {
                label: "待办内容模板",
                span: 2
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tableInfo.detailData.contentTemplate), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, {
                label: "备注",
                span: 2
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tableInfo.detailData.toDoTemplateConfig?.remark), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_descriptions, {
            title: "短信",
            bordered: "",
            layout: "vertical",
            column: 4,
            style: {"margin-top":"16px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_descriptions_item, {
                label: "是否发送短信",
                span: 1
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tableInfo.detailData.isSendSms ? '是' : '否'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, {
                label: "短信模板标识",
                span: 1
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tableInfo.detailData.smsTemplateCode), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, {
                label: "短信模板内容配置",
                span: 3
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tableInfo.detailData.smsTemplateConfig), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_edit_or_add_modal, {
      "modal-config": _ctx.addInfo.modalConfig,
      form: _ctx.addInfo.form,
      "form-config": _ctx.addInfo.formConfig,
      rules: _ctx.addInfo.rules,
      layoutConfig: {label: 6, wrapper: 16},
      onOk: _ctx.addInfo.getOk,
      onCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.addInfo.cancel()))
    }, null, 8, ["modal-config", "form", "form-config", "rules", "onOk"])
  ]))
}